import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { sendAnalyticsEvent } from 'dpl/util/analytics';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_USER_JOURNEYS
} from 'dpl/constants/analytics';
import { PUPPY_TRAINING_PROGRAM } from 'dpl/shared/constants/urls';

export default function PuppyCollegeGetStartedLink({ className, variant }) {
  const classes = classnames(
    `inline-flex align-items-center justify-center button button--${variant} fw-medium nowrap`,
    className
  );

  function handleButtonClick() {
    sendAnalyticsEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      button_cta: 'Get Started',
      user_journey: ANALYTICS_USER_JOURNEYS.PAYMENTS
    });
    window.location.assign(PUPPY_TRAINING_PROGRAM);
  }

  return (
    <div className="PuppyCollegeGetStartedLink">
      <button type="button" onClick={handleButtonClick} className={classes}>
        Get started
      </button>
    </div>
  );
}

PuppyCollegeGetStartedLink.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'white'])
};

PuppyCollegeGetStartedLink.defaultProps = {
  className: null,
  variant: 'primary'
};
